import { colord } from "colord";
import { clamp as rawClamp } from "@foretagsplatsen/core-helpers/number";

/**
 * Lightens a base color according to a list of shade values.
 */
export function getColorShades(baseColor, shades) {
	const hexColor = parseInt(baseColor.substring(1), 16);

	return shades.map((amount) => {
		const newColor = lightenColor(hexColor, amount);
		return hexColorToString(newColor);
	});
}

/**
 * Lighten an hexadecimal color according to the amount value.
 * (it darkens the color if the amount is negative).
 */
export function lightenColor(hexColor, amount) {
	const r = (hexColor >> 16) + amount;
	const b = ((hexColor >> 8) & 0x00_ff) + amount;
	const g = (hexColor & 0x00_00_ff) + amount;

	// each primary color must stay between 0 and ff
	const min = parseInt("00", 16);
	const max = parseInt("ff", 16);
	const clamp = (x) => rawClamp(x, min, max);

	return clamp(g) | (clamp(b) << 8) | (clamp(r) << 16);
}

/**
 * Convert an hexadecimal color to a standard string (e.g., ffff -> "#00ffff").
 */
export function hexColorToString(hexColor) {
	const colorString = hexColor.toString(16);
	const missing0s = "00000".substring(0, 6 - colorString.length);
	return `#${missing0s}${colorString}`;
}

/**
 * Convert a color to 3 CSS variables, one for each HSL component.
 * The key is used as a prefix for the variable names.
 * It returns a string that can be used in a CSS file.
 *
 * @param {object} options - Object parameters
 * @param {string} options.key - The prefix for the CSS variables
 * @param {string} options.color - The color to convert
 * @return {string}
 */
export function asHSLCss({ key, color }) {
	const { h, s, l } = colord(color).toHsl();

	return `
				--${key}-h: ${h};
                --${key}-s: ${s}%;
                --${key}-l: ${l}%;
            `;
}

/**
 * Convert a color to a CSS variable as a hexadecimal color.
 * The key is used as the variable name
 * Returns a string that can be used in a CSS file.
 *
 * @param {object} options - Object parameters
 * @param {string} options.key - The name of the CSS variable
 * @param {string} options.color - The color to convert
 * @return {string}
 */
export function asHexCss({ key, color }) {
	return `
				--${key}: ${color};
            `;
}
